module.exports = __webpack_public_path__ + "img/02_pascal-plisson_3_NEW.236b089c.jpg";